import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp, faThumbsDown } from "@fortawesome/free-solid-svg-icons";
import "./css/AnalysisFeedbackBar.css";
import { useTranslation } from "../../../../i18n/LanguageContext";

const AnalysisFeedbackBar = ({ analysisKey, onNegativeFeedback }) => {
  const { t } = useTranslation();
  // Track feedback per analysis using a map keyed by analysisKey
  const [feedbackMap, setFeedbackMap] = useState({});
  const prevKeyRef = useRef(analysisKey);

  // When analysisKey changes, keep existing map but don't reset it
  useEffect(() => {
    prevKeyRef.current = analysisKey;
  }, [analysisKey]);

  const feedback = analysisKey ? feedbackMap[analysisKey] || null : null;

  const handleFeedback = (type) => {
    if (!analysisKey) return;

    const newValue = feedback === type ? null : type;

    setFeedbackMap((prev) => ({
      ...prev,
      [analysisKey]: newValue,
    }));

    if (newValue === "negative" && onNegativeFeedback) {
      onNegativeFeedback();
    }
  };

  return (
    <div className="feedback-bar">
      <span className="feedback-prompt">{t("feedback.prompt")}</span>
      <div className="feedback-buttons">
        <button
          type="button"
          className={`feedback-btn ${feedback === "positive" ? "active-positive" : ""}`}
          onClick={() => handleFeedback("positive")}
          aria-label={t("feedback.helpful")}
          title={t("feedback.yesHelpful")}
        >
          <FontAwesomeIcon icon={faThumbsUp} />
        </button>
        <button
          type="button"
          className={`feedback-btn ${feedback === "negative" ? "active-negative" : ""}`}
          onClick={() => handleFeedback("negative")}
          aria-label={t("feedback.notHelpful")}
          title={t("feedback.notHelpful")}
        >
          <FontAwesomeIcon icon={faThumbsDown} />
        </button>
      </div>
      {feedback === "positive" && (
        <span className="feedback-thanks">{t("feedback.thanks")}</span>
      )}
      {feedback === "negative" && (
        <span className="feedback-nudge">{t("feedback.nudge")}</span>
      )}
    </div>
  );
};

export default AnalysisFeedbackBar;
